import { TOGGLE_BUTTONS_ARRAY_BUTTON, CHANGE_BUTTONS_ARRAY_BUTTON } from './constants'

export function toggleButtonsArrayButton(moduleName, arrayName, name) {
    return {
        type: TOGGLE_BUTTONS_ARRAY_BUTTON,
        data: {
            moduleName,
            arrayName,
            name,
        },
    }
}

export function changebuttonsArrayButton(moduleName, arrayName, name, value) {
    return {
        type: CHANGE_BUTTONS_ARRAY_BUTTON,
        data: {
            moduleName,
            arrayName,
            name,
            value,
        },
    }
}
